import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormatDatePipe } from '../../../pipes/format-date.pipe';
import { TimelineModule } from 'primeng/timeline';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-track-trace',
  imports: [CommonModule, ButtonModule, FormatDatePipe, TimelineModule, LineBreakPipe],
  templateUrl: './track-trace.component.html',
})
export class TrackTraceComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  getGoogleMapsLink(value: unknown): string | null {
    const location = (value ?? '').toString().trim();
    if (!location) {
      return null;
    }
    if (this.isDirectMapsUrl(location)) {
      return location;
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
  }

  getLocationLinkStyle(cte: ProductDesignTemplatePageModuleDataContent): Record<string, string> {
    const locationLinkStyles = (cte?.styles as { locationLink?: Record<string, string> } | undefined)
      ?.locationLink;
    return {
      color: '#2563eb',
      fontSize: '11px',
      fontWeight: '600',
      textDecoration: 'none',
      ...(locationLinkStyles || {}),
    };
  }

  private isDirectMapsUrl(value: string): boolean {
    try {
      const parsed = new URL(value);
      const host = parsed.hostname.toLowerCase();
      const isGoogleHost = host === 'maps.app.goo.gl' || host.endsWith('google.com');
      const hasMapPath = parsed.pathname.toLowerCase().includes('/maps');
      return isGoogleHost && (host === 'maps.app.goo.gl' || hasMapPath);
    } catch {
      return false;
    }
  }
}
